var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "new-main" },
    [
      _c(
        "div",
        { staticClass: "left-col" },
        [
          _vm.banners.length > 0
            ? _c("TextBanner", {
                on: {
                  "open-medical-trend": _vm.openMedicalTrendPopup,
                  "open-drug-info": _vm.openDrugInfoPopup,
                  "open-survey": _vm.openSurveyPopup,
                  "open-webseminar": _vm.linkToSeminar,
                  "open-notice": _vm.linkToNotice,
                  "open-event": _vm.linkToEvent,
                  "open-drug-landing": _vm.openDrugLanding,
                },
              })
            : _vm._e(),
          _vm.isLiveOptionActivity || _vm.isSurveyActivity
            ? _c("Content", {
                on: {
                  "open-drug-info": _vm.openDrugInfoPopup,
                  "open-survey": _vm.openSurveyPopup,
                },
              })
            : _vm._e(),
          _vm.banners.length > 0
            ? _c("LeftBanner", {
                on: {
                  "open-medical-trend": _vm.openMedicalTrendPopup,
                  "open-drug-info": _vm.openDrugInfoPopup,
                  "open-survey": _vm.openSurveyPopup,
                  "open-webseminar": _vm.linkToSeminar,
                  "open-notice": _vm.linkToNotice,
                  "open-event": _vm.linkToEvent,
                },
              })
            : _vm._e(),
          _c("Kma", {
            on: { "open-kma": _vm.openKma, "link-with-stat": _vm.linkWithStat },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-col" },
        [
          _c("Account", { on: { "link-with-stat": _vm.linkWithStat } }),
          _c("div", { staticClass: "easy-register-wrap" }, [
            _c("h2", [
              _vm._v(" 실행 앱 버전 : " + _vm._s(_vm.appVersion) + " "),
            ]),
            _c("h2", [
              _vm._v(" 연결된 서버 : 2번 서버 (3.0.1.7 이하 버전 연결) "),
            ]),
          ]),
          _vm.isDrugLandingActivity
            ? _c("LiveLanding", {
                on: { "open-drug-landing": _vm.openDrugLanding },
              })
            : _vm._e(),
          _vm.banners.length > 0
            ? _c("RightBanner", {
                on: {
                  "open-medical-trend": _vm.openMedicalTrendPopup,
                  "open-drug-info": _vm.openDrugInfoPopup,
                  "open-survey": _vm.openSurveyPopup,
                  "open-webseminar": _vm.linkToSeminar,
                  "open-notice": _vm.linkToNotice,
                  "open-event": _vm.linkToEvent,
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "custom-content-area" }, [
            _vm._m(0),
            _c("div", { staticClass: "more-tooltip" }, [_c("HoverInfoTip")], 1),
          ]),
        ],
        1
      ),
      _vm.mountedDrugInfoPopup
        ? _c("popup-drug-info-view", {
            ref: "popupDrugInfoView",
            on: { statUpdate: _vm.statUpdateDrugInfo },
          })
        : _vm._e(),
      _vm.mountedMedicalPopup
        ? _c("popup-medical-view", {
            ref: "popupMedicalView",
            on: { statUpdate: _vm.statUpdateMedicalTrend },
          })
        : _vm._e(),
      _vm.mountedSurveyPopup
        ? _c("popup-survey-view", {
            attrs: {
              id: _vm.surveyId,
              "entry-service-type": _vm.surveyEntryService,
              "entry-position-type": _vm.surveyEntryPosition,
              "entry-state-type": _vm.surveyEntryState,
              "show-modal": _vm.showSurvey,
            },
            on: { close: _vm.closeSurveyView },
          })
        : _vm._e(),
      _c("alert-dialog", { attrs: { options: _vm.alertProps } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn-custom-content" }, [
      _vm._v(" 맞춤형 컨텐츠"),
      _c("i"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }